module.exports = __webpack_public_path__ + "static/media/CL 6.ed51a419.mp3";